import Drawer from "../../../../drawer/Drawer";
import ManageOrganization from "../ManageOrganization";

const ManageOrganizationDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update Company" : "Add Company"}
      subtitle="View, update and modify Company details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManageOrganization
          getResponse={getResponse}
          close={close}
          data={data}
        />
      </div>
    </Drawer>
  );
};

export default ManageOrganizationDrawer;
